import React, { useState, useEffect } from 'react';
import { text } from '../../ultils/constant';
import { Province, RelatedPost, SideBar } from '../../components';
import { List, Pagination } from './index';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../store/actions';
import { formatVietnameseToString } from '../../ultils/common/formatVietnameseToString ';
const Rental = () => {
    const { categories, prices, areas } = useSelector((state) => state.app);
    const [categoryCode, setCategoryCode] = useState('none');
    const location = useLocation();
    const dispatch = useDispatch();
    useEffect(() => {
        const category = categories?.find((item) => `/${formatVietnameseToString(item.value)}` === location.pathname);
        console.log(category);
        if (category) {
            setCategoryCode(category.code);
        }
    }, [location]);
    return (
        <div className=" w-full flex flex-col gap-3">
            <div>
                <h1 className="text-[28px] font-bold">{text.HOME_TITLE}</h1>
                <p className="text-sm text-gray-700">{text.HOME_DESCRIPTION}</p>
            </div>
            <Province />
            <div className="w-full flex gap-4">
                <div className="w-[70%]">
                    <List categoryCode={categoryCode} />
                    <Pagination /*page={params.get('page')} */ />
                </div>
                <div className="w-[30%] flex flex-col justify-start items-center gap-4">
                    <SideBar isDouble={true} type="priceCode" content={prices} title="Xem theo giá " />
                    <SideBar isDouble={true} type="areaCode" content={areas} title="Xem theo diện tích " />
                    <RelatedPost />
                </div>
            </div>
        </div>
    );
};

export default Rental;
